/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 8L7 8.66667V8.66667C8.60965 9.73977 9.41447 10.2763 10.2691 10.5338C11.398 10.8739 12.602 10.8739 13.7309 10.5338C14.5855 10.2763 15.3904 9.73977 17 8.66667V8.66667L18 8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="3"
				width="20"
				height="18"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="3"
				width="20"
				height="18"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M18 8L17 8.66667L16.4376 9.0416C14.8338 10.1108 14.0319 10.6454 13.1652 10.8531C12.3992 11.0366 11.6008 11.0366 10.8348 10.8531C9.96808 10.6454 9.16618 10.1108 7.5624 9.0416L7 8.66667L6 8M10 21H14C16.8003 21 18.2004 21 19.27 20.455C20.2108 19.9757 20.9757 19.2108 21.455 18.27C22 17.2004 22 15.8003 22 13V11C22 8.19974 22 6.79961 21.455 5.73005C20.9757 4.78924 20.2108 4.02433 19.27 3.54497C18.2004 3 16.8003 3 14 3H10C7.19974 3 5.79961 3 4.73005 3.54497C3.78924 4.02433 3.02433 4.78924 2.54497 5.73005C2 6.79961 2 8.19974 2 11V13C2 15.8003 2 17.2004 2.54497 18.27C3.02433 19.2108 3.78924 19.9757 4.73005 20.455C5.79961 21 7.19974 21 10 21Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 2.79497C5.04961 2.25 6.44974 2.25 9.25 2.25H14.75C17.5503 2.25 18.9504 2.25 20.02 2.79497C20.9608 3.27433 21.7257 4.03924 22.205 4.98005C22.75 6.04961 22.75 7.44974 22.75 10.25V13.75C22.75 16.5503 22.75 17.9504 22.205 19.02C21.7257 19.9608 20.9608 20.7257 20.02 21.205C18.9504 21.75 17.5503 21.75 14.75 21.75H9.25C6.44974 21.75 5.04961 21.75 3.98005 21.205C3.03924 20.7257 2.27433 19.9608 1.79497 19.02C1.25 17.9504 1.25 16.5503 1.25 13.75V10.25C1.25 7.44974 1.25 6.04961 1.79497 4.98005C2.27433 4.03924 3.03924 3.27433 3.98005 2.79497ZM6.41603 7.37596C6.07138 7.1462 5.60573 7.23933 5.37596 7.58397C5.1462 7.92862 5.23933 8.39427 5.58397 8.62404L6.58397 9.2907L6.70034 9.36829L6.70034 9.3683C8.19864 10.3674 9.09026 10.9619 10.0527 11.2519C11.3227 11.6346 12.6773 11.6346 13.9473 11.2519C14.9097 10.9619 15.8014 10.3674 17.2996 9.3683L17.2997 9.36829L17.416 9.2907L18.416 8.62404C18.7607 8.39427 18.8538 7.92862 18.624 7.58397C18.3943 7.23933 17.9286 7.1462 17.584 7.37596L16.584 8.04263C14.9337 9.14281 14.2367 9.59812 13.5145 9.81569C12.5268 10.1133 11.4732 10.1133 10.4855 9.81569C9.76334 9.59812 9.0663 9.14281 7.41603 8.04263L6.41603 7.37596Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 8.07099 22 7.60649 21.9384 7.21783C21.5996 5.07837 19.9216 3.40042 17.7822 3.06156C17.3935 3 16.929 3 16 3H10C7.19974 3 5.79961 3 4.73005 3.54497C3.78924 4.02433 3.02433 4.78924 2.54497 5.73005C2 6.79961 2 8.19974 2 11V13C2 15.8003 2 17.2004 2.54497 18.27C3.02433 19.2108 3.78924 19.9757 4.73005 20.455C5.79961 21 7.19974 21 10 21H16C16.929 21 17.3935 21 17.7822 20.9384C19.9216 20.5996 21.5996 18.9216 21.9384 16.7822C22 16.3935 22 15.929 22 15V15V14.5M18 8L17 8.66667L16.4376 9.0416C14.8338 10.1108 14.0319 10.6454 13.1652 10.8531C12.3992 11.0366 11.6008 11.0366 10.8348 10.8531C9.96808 10.6454 9.16618 10.1108 7.5624 9.0416L7 8.66667L6 8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18 8L17 8.66667L16.4376 9.0416C14.8338 10.1108 14.0319 10.6454 13.1652 10.8531C12.3992 11.0366 11.6008 11.0366 10.8348 10.8531C9.96808 10.6454 9.16618 10.1108 7.5624 9.0416L7 8.66667L6 8M10 21H14C16.8003 21 18.2004 21 19.27 20.455C20.2108 19.9757 20.9757 19.2108 21.455 18.27C22 17.2004 22 15.8003 22 13V11C22 8.19974 22 6.79961 21.455 5.73005C20.9757 4.78924 20.2108 4.02433 19.27 3.54497C18.2004 3 16.8003 3 14 3H10C7.19974 3 5.79961 3 4.73005 3.54497C3.78924 4.02433 3.02433 4.78924 2.54497 5.73005C2 6.79961 2 8.19974 2 11V13C2 15.8003 2 17.2004 2.54497 18.27C3.02433 19.2108 3.78924 19.9757 4.73005 20.455C5.79961 21 7.19974 21 10 21Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 2.25C6.44974 2.25 5.04961 2.25 3.98005 2.79497C3.03924 3.27433 2.27433 4.03924 1.79497 4.98005C1.25 6.04961 1.25 7.44974 1.25 10.25V13.75C1.25 16.5503 1.25 17.9504 1.79497 19.02C2.27433 19.9608 3.03924 20.7257 3.98005 21.205C5.04961 21.75 6.44974 21.75 9.25 21.75H14.75C17.5503 21.75 18.9504 21.75 20.02 21.205C20.9608 20.7257 21.7257 19.9608 22.205 19.02C22.75 17.9504 22.75 16.5503 22.75 13.75V10.25C22.75 7.44974 22.75 6.04961 22.205 4.98005C21.7257 4.03924 20.9608 3.27433 20.02 2.79497C18.9504 2.25 17.5503 2.25 14.75 2.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.37592 7.58393C5.60568 7.23929 6.07134 7.14616 6.41598 7.37592L7.41598 8.04259C9.06626 9.14277 9.7633 9.59808 10.4854 9.81565C11.4732 10.1133 12.5267 10.1133 13.5145 9.81565C14.2366 9.59808 14.9337 9.14277 16.5839 8.04259L17.5839 7.37592C17.9286 7.14616 18.3942 7.23929 18.624 7.58393C18.8538 7.92858 18.7606 8.39423 18.416 8.624L17.416 9.29066C17.3768 9.31679 17.338 9.34265 17.2996 9.36825C15.8013 10.3673 14.9097 10.9619 13.9472 11.2519C12.6772 11.6345 11.3227 11.6345 10.0527 11.2519C9.09022 10.9619 8.19859 10.3673 6.7003 9.36825C6.66191 9.34265 6.62313 9.31679 6.58393 9.29066L5.58393 8.624C5.23929 8.39423 5.14616 7.92858 5.37592 7.58393Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
